import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PackageDashboardMeta } from '@lib/api/models/package';

export interface PriorityOption {
    id: string;
    name: string;
    delay: number;
    status: boolean;
}

export interface Priority extends PriorityOption {
    description: string;
    status: boolean;
    created_at: string;
    updated_at: string;
    pivot?: {
        region_id: string;
    }
}

export interface PrioritySingleResponse {
    data: Priority;
}

export interface StorePriorityRequest {
    name: string;
    description: string;
    delay: number;
    status: boolean;
}

export interface PackagesByPriority {
    regions: {
        id: string;
        region_name: string;
        priorities: {
            id: string;
            priority_name: string;
            priority_description: string;
            packages: PackageDashboardMeta[];
        }[];
    }[];
}

export function createPriorityFormGroup(priority?: Priority) {
    return new FormGroup({
        name: new FormControl<string>(priority?.name ?? '', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(255)
        ]),
        description: new FormControl<string>(priority?.description ?? '', [
            Validators.minLength(10),
            Validators.maxLength(500)
        ]),
        delay: new FormControl<number>(priority?.delay ?? 0, [
            Validators.required,
            Validators.min(0),
            Validators.max(10080)
        ])
    });
}
